import { render, staticRenderFns } from "./AddressDetil.vue?vue&type=template&id=242c3aae&scoped=true&"
import script from "./AddressDetil.vue?vue&type=script&lang=js&"
export * from "./AddressDetil.vue?vue&type=script&lang=js&"
import style0 from "./AddressDetil.vue?vue&type=style&index=0&id=242c3aae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242c3aae",
  null
  
)

export default component.exports